import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=6fcd6e9f&scoped=true&"
import script from "./DashboardView.vue?vue&type=script&lang=ts&"
export * from "./DashboardView.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardView.vue?vue&type=style&index=0&id=6fcd6e9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcd6e9f",
  null
  
)

export default component.exports